import { depositWithdrawalMethodsChoices, forwarderTypeChoices } from '@/components/global/options/selectOptions.jsx';
import { operatorChoices } from '@/constants/Operators.js';
import { formatOptionalIntegerInput, formatOptionalNumberInput } from '@/components/retailChain/validators/retailChainValidators.js';

export const DISCOUNT_LEVELS = [1, 2, 3, 4, 5, 6];

export const couponSourceChoices = [
    { id: 'comp', name: 'Comp' },
    { id: 'zwrotka', name: 'Zwrotka' },
    { id: 'eurocash', name: 'Eurocash' },
    { id: 'maasloop', name: 'MaasLoop' },
    { id: 'kaucja', name: 'Kaucja' },
];

export const choiceName = (choices, id) => choices.find(choice => choice.id === id)?.name || id;

export const joinDiscountValues = (record, sourcePrefix, formatValue) =>
    DISCOUNT_LEVELS.map(level => {
        const formatted = formatOptionalIntegerInput(record?.[`${sourcePrefix}${level}`]);
        return formatted === '' ? '-' : formatValue(formatted);
    }).join(' · ');

export const joinChoiceNames = (values, choices) => {
    const ids = (Array.isArray(values) ? values : []).map(value => (value && typeof value === 'object' ? value.id : value)).filter(Boolean);
    if (ids.length === 0) {
        return '';
    }

    return ids.map(id => choiceName(choices, id)).join(', ');
};

const display = value => (value === null || value === undefined || value === '' ? '—' : value);

export const configurationTextValue = (record, key, translate) => {
    if (!record) {
        return '—';
    }

    if (key === 'forwarderType') {
        return display(record.forwarderType ? choiceName(forwarderTypeChoices(translate), record.forwarderType) : '');
    }

    if (key === 'operators') {
        return display(joinChoiceNames(record.operators, operatorChoices));
    }

    if (key === 'couponSource') {
        return display(record.couponSource ? choiceName(couponSourceChoices, record.couponSource) : '');
    }

    if (key === 'depositWithdrawalMethods') {
        return display(joinChoiceNames(record.depositWithdrawalMethods, depositWithdrawalMethodsChoices(translate)));
    }

    if (key === 'defaultDepositValue') {
        return display(formatOptionalNumberInput(record.defaultDepositValue));
    }

    if (key === 'defaultDepositPoints') {
        return display(formatOptionalIntegerInput(record.defaultDepositPoints));
    }

    if (key === 'discountLimits') {
        return joinDiscountValues(record, 'discountLimitL', value => value);
    }

    if (key === 'discountValues') {
        return joinDiscountValues(record, 'discountValueL', value => `${value}%`);
    }

    return '—';
};
